import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import { getNotationFromValue } from 'containers/CarnetsDeNotes/Evaluations/utils/getNotationFromValue';
import { Infobox } from 'components/Callout/Infobox';
import { NotationSystemData } from './types';

interface Props {
  notationSystem: NotationSystemData;
}

export function ExampleCallout(props: Props) {
  const { t } = useTranslation(['userSettings', 'common']);
  const { notationSystem } = props;
  const positiveValues = notationSystem.values.filter(v => v.value > 0);
  if (positiveValues.length < 2) return null;

  const firstNotation = positiveValues[0];
  const middleIndex = Math.floor(positiveValues.length / 2);
  const middleNotation = positiveValues[middleIndex];

  const mean = Math.round((firstNotation.value * 2 + middleNotation.value) / 3);
  const equivalentNotation = getNotationFromValue(mean, notationSystem.values);

  return (
    <Infobox
      intent="primary"
      title={t('userSettings:notationSystems.exampleTitle')}
    >
      <Trans
        i18nKey="userSettings:notationSystems.exampleDescription"
        values={{
          firstLabel: firstNotation.label,
          middleLabel: middleNotation.label,
          mean,
        }}
      >
        Deux <strong>{'{{firstLabel}}'}</strong> et une{' '}
        <strong>{'{{middleLabel}}'}</strong> auront pour moyenne{' '}
        <strong>{'{{mean}}/100'}</strong>.
      </Trans>
      <br />
      <Trans
        i18nKey="userSettings:notationSystems.exampleEquivalence"
        values={{
          mean,
          equivalent: equivalentNotation,
        }}
      >
        Une note de <strong>{'{{mean}}/100'}</strong> équivaut à une note{' '}
        <strong>{'{{equivalent}}'}</strong>.
      </Trans>
    </Infobox>
  );
}
